import { Fab, Typography, makeStyles, Box, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, ActionItems } from "src/common/components";
import { IconArrowDropDown } from "src/common/icons";
import { IActionPlan } from "src/common/types";
import * as qs from "query-string";

const useStyles = makeStyles((theme: any) => ({
  arrow: {
    fontSize: "1.35rem"
  },
  expandButton: {
    background: "none" as "none",
    boxShadow: "none" as "none"
  }
}));

interface IOwnProps {
  actionPlan: IActionPlan;
}

const ActionItemsCard = ({ actionPlan }: IOwnProps) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();

  const classes = useStyles();

  return (
    <div>
      <Accordion
        style={{ boxShadow: "0 2px 4px 0 rgb(219 219 219 / 50%)", border: "1px solid #e6e6e6", borderRadius: "4px" }}
      >
        <AccordionSummary
          expandIcon={
            <Fab className={classes.expandButton} size="small" disableRipple>
              <Typography color="primary" className={classes.arrow}>
                <IconArrowDropDown />
              </Typography>
            </Fab>
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Link
            to={`/${language}/dashboard/my-feedbacks/talk-sheet/${actionPlan.talkId}?${btoa(
              qs.stringify(
                { supported: actionPlan.supportedLanguages },
                {
                  arrayFormat: "comma"
                }
              )
            )}`}
          >
            {actionPlan.cycleName}
          </Link>
        </AccordionSummary>
        <AccordionDetails>
          <Box display="flex" flexDirection="column" p={2} width="100%">
            {actionPlan?.actionPlanItems?.length > 0 ? (
              actionPlan?.actionPlanItems?.map(item => {
                return <ActionItems key={item.id} item={item} disabled />;
              })
            ) : (
              <Typography>{t("feedback.page.talk-sheet.actionPlan.noLastActionPlan")}</Typography>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ActionItemsCard;
